export const generativeAiAppGroupIdAgentPreview = "/:app_group_id/generative_ai/agent/preview";
